module.exports = __webpack_public_path__ + "static/media/BocadosalsaXO.ba04a7d2.jpg";